import { render } from "./RegistModal.vue?vue&type=template&id=b6b3ef86"
import script from "./RegistModal.vue?vue&type=script&lang=js"
export * from "./RegistModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__